import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'pagination',
  template: `
    <ul class="pagination__list">
      <li 
        *ngIf="total > MAX_PAGE"
        class="pagination__item" 
        [ngClass]="{
          'pagination__item--disabled': (current <= 0)
        }"
        (click)="prevPage()"
      > < </li>
    
      <li 
        *ngFor="let page of pages" 
        (click)="setPage(page)"
        class="pagination__item"
        [ngClass]="{
          'pagination__item--selected': (page == current)
        }"
      >{{ page + 1}}</li> 
      
      <li 
        *ngIf="total > MAX_PAGE"
        class="pagination__item" 
        [ngClass]="{
          'pagination__item--disabled': (current >= total - 1)
        }"
        (click)="nextPage()"
      > > </li>
    </ul>
  `,
  host: {
    class: 'pagination'
  }
})
export class PaginationComponent  {
  public MAX_PAGE: number = 5;
  
  public pages:Array<number>;
  @Input() public set total(value: number) {
    this._total = value;
    this.pages = [];
    for (var i: number = 0; i < Math.min(this.MAX_PAGE, this._total); i++) {
      this.pages.push(i)
    }
    this.current = this.pages[0];
  }
  public get total():number {
    return this._total;
  }
  private _total:number;

  public current: number;

  @Output() onSetPage: EventEmitter<any> = new EventEmitter<any>();

  public setPage(index:number) {
    this.current = index;

    var i: number;
    if (this._total > this.MAX_PAGE) {
      if (index >= this._total - 1) {
        for (i = 0; i < this.MAX_PAGE; i++) {
          this.pages[i] = this._total - this.MAX_PAGE + i;
        }
      } else if (index + 1 >= this.MAX_PAGE) {
        for (i = 0; i < this.MAX_PAGE; i++) {
          this.pages[i] = i + index + 1 - this.MAX_PAGE + 1;
        }
      } else if (index + 1 < this.MAX_PAGE) {
        for (i = 0; i < this.MAX_PAGE; i++) {
          this.pages[i] = i;
        }
      }
    }

    this.onSetPage.emit(index);
  }

  public prevPage() {
    if (this.current > 0) {
      this.setPage(this.current - 1);
    }
  }

  public nextPage() {
    if (this.current < this._total - 1 ) {
      this.setPage(this.current + 1);
    }
  }

}
